export default "__VITE_ASSET__CgQsMifl__"